import React, {
  forwardRef,
} from "react";

import FormInput from "./FormInput";

export interface FormPhoneInputProps {

  label: string;

  value: string;

  onValueChange(
    value: string
  ): void;

  phoneCode?: string;

  phoneLength?: number;

  phonePattern?: string;

  placeholder?: string;

  example?: string;

  required?: boolean;

  readOnly?: boolean;

  error?: string;

  helperText?: string;

  containerClassName?: string;

  className?: string;
}

const FormPhoneInput = forwardRef<
  HTMLInputElement,
  FormPhoneInputProps
>(
  (
    {
      label,

      value,

      onValueChange,

      phoneCode,

      phoneLength,

      placeholder,

      example,

      required = false,

      readOnly = false,

      error,

      helperText,

      containerClassName,

      className,
    },
    ref
  ) => {

    //----------------------------------------------------
    // Change
    //----------------------------------------------------

    function handleChange(
      input: string
    ) {

      let digits =
        input.replace(
          /\D/g,
          ""
        );

      if (
        phoneLength
      ) {
        digits =
          digits.substring(
            0,
            phoneLength
          );
      }

      onValueChange(
        digits
      );
    }

    //----------------------------------------------------
    // Validation
    //----------------------------------------------------

    let validationError =
      error;

    if (
      !validationError &&
      phoneLength &&
      value.length > 0 &&
      value.length !== phoneLength
    ) {

      validationError =
        `Phone number must contain ${phoneLength} digits.`;

    }

    //----------------------------------------------------

    return (

      <div
        className={`flex ${containerClassName ?? ""}`}
      >
        <FormInput
          ref={ref}
          label={label}
          inputPrefix={phoneCode}
          value={value}
          validation="numeric"
          required={required}
          readOnly={readOnly}
          placeholder={
            placeholder ??
            "Phone Number"
          }
          helperText={
            `sample: ${helperText ?? example}`
          }
          error={validationError}
          maxLength={phoneLength}
          onValueChange={handleChange}
          className={`
            rounded-l-none
            ${className ?? ""}
          `}
        />

      </div>

    );

  }
);

FormPhoneInput.displayName =
  "FormPhoneInput";

export default FormPhoneInput;